import React from 'react';
import { Panel } from 'react-bootstrap';
import PropTypes from 'prop-types';

const FilterSectionAccordian = (props) => {
  const { colFilter, checkBoxChangeHandler, activeKey, searchQuery } = props;
  const getFilteredFilters = (filters) => {
    const regex = new RegExp(searchQuery, 'i');
    return filters
      .filter((filter) => !_.isEmpty(filter.title) && !_.isEmpty(filter.title.match(regex)))
      .sort((filter1, filter2) => {
        return filter1.selected === filter2.selected ? 0 : filter1.selected ? -1 : 1;
      });
  };
  const appliedFiltersCount = colFilter.filters.filter((filter) => filter.selected).length;

  const getChevronClass = (key) => {
    return activeKey === key ? 'glyphicon glyphicon-chevron-up' : 'glyphicon glyphicon-chevron-down';
  };
  return (
    <Panel eventKey={colFilter.key}>
      <Panel.Heading>
        <Panel.Toggle componentClass="div">
          <div className="filter-accordian-header">
            <div className="title">
              {colFilter.displayName}
              {' '}
              <span className="count">{appliedFiltersCount > 0 ? `(${appliedFiltersCount})` : null}</span>
            </div>
            <i className={getChevronClass(colFilter.key)} />
          </div>
        </Panel.Toggle>
      </Panel.Heading>
      <Panel.Body collapsible>
        {getFilteredFilters(colFilter.filters).map((filter) => {
          return (
            <div key={filter.value.toString()} className="checkbox-container">
              <input
                id={filter.value.toString()}
                type="checkbox"
                checked={filter.selected}
                onChange={() => checkBoxChangeHandler(colFilter.key, filter.value)}
              />
              <label htmlFor={filter.value.toString()}>{filter.title}</label>
            </div>
          );
        })}
      </Panel.Body>
    </Panel>
  );
};

FilterSectionAccordian.propTypes = {
  colFilter: PropTypes.object,
  checkBoxChangeHandler: PropTypes.func,
  activeKey: PropTypes.string,
  searchQuery: PropTypes.string,
};

export default FilterSectionAccordian;
